import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import { createContext, useContext } from 'react';

var CogsMenuContext = /*#__PURE__*/createContext(null);
var useMenuContext = function useMenuContext() {
  var context = useContext(CogsMenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a CogsMenuContext');
  }
  return context;
};

export { CogsMenuContext, useMenuContext };
